export default {
  data () {
    return {
      ups: require('@/assets/images/go-up.png'),
      downs: require('@/assets/images/decline.png'),
      timeData: {},
      keyCode: 0
    }
  },
  computed: {
  },
  methods: {
    checkUndefineAndNull (value) {
      if (value === 0 || value) { return true }
      return false
    },
    seeDetails (name, query) {
      if (window.event.keyCode) return false
      this.$store.dispatch('toggleRoute', {
        name: this.$route.name,
        query: this.$route.query
      })
      localStorage.setItem('returnPage', location.pathname + location.search)
      location.href = name
      // this.$router.push({
      //   name: name,
      //   query: query
      // })
    },
    deviceType () {
      return this.$service.state.deviceType
    },
    getUpTarget (index) {
      if (index === '0_0') {
        return '#' + this.$route.name
      }
    },
    numberSplitWithComma (num) {
      const number = parseFloat((num * 1).toFixed(2))
      num = number + ''
      if (!num.includes('.')) {
        num += '.'
      }
      return num.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
        return $1 + ','
      }).replace(/\.$/, '')
      // if (typeof n !== 'string' && typeof n !== 'number') {
      //   return n
      // }
      // if (!n) {
      //   return n
      // }
      // if (typeof n !== 'string') {
      //   n = n.toString()
      // }
      // const num = n.split('.')
      // return `${this.$cUtils.format.fillNumber(parseInt(num[0]))}${num[1] ? '.' + num[1].substring(0,2) : ''}`
    },
    getTimerShaft () {
      const timestamp = (new Date()).getTime()
      const startTime = timestamp - (86400000 * 45)
      const endTime = timestamp + (86400000 * 45)
      const timerShaft = []
      const totalDay = (endTime - startTime) / 86400000
      const dayRatio = 100 / totalDay
      const weekRatio = dayRatio * 7
      const startTimeWeek = new Date(startTime).getDay()
      let start
      if (startTimeWeek === 1) {
        start = startTime + (86400000 * 7)
        timerShaft.push({
          ratio: weekRatio,
          time: this.$cUtils.format.formatDate(new Date(startTime), 'MM-dd')
        })
      } else {
        start = startTime + (86400000 * (startTimeWeek ? 8 - startTimeWeek : 1))
        timerShaft.push({
          ratio: startTimeWeek ? dayRatio * (7 - startTimeWeek) : dayRatio
        })
      }
      const mistiming = parseInt(((endTime - start) / 86400000) / 7) + 1
      for (var i = 1; i < mistiming; i++) {
        const curTime = startTime + (86400000 * i * 7)
        timerShaft.push({
          ratio: weekRatio,
          time: this.$cUtils.format.formatDate(new Date(curTime), 'MM-dd')
        })
      }
      const startTimeArr = this.$cUtils.format.formatDate(new Date(startTime), 'yyyy-MM-dd').split('-')
      const curTimeArr = this.$cUtils.format.formatDate(new Date(), 'yyyy-MM-dd').split('-')
      const endTimeArr = this.$cUtils.format.formatDate(new Date(endTime), 'yyyy-MM-dd').split('-')
      const timeMap = {
        up: {
          year: startTimeArr[0],
          month: startTimeArr[1],
          day: startTimeArr[2]
        },
        cur: {
          year: curTimeArr[0],
          month: curTimeArr[1],
          day: curTimeArr[2],
          onDay: curTimeArr[2]
        },
        down: {
          year: endTimeArr[0],
          month: endTimeArr[1],
          day: endTimeArr[2]
        }
      }
      this.timeData = {
        timerShaft,
        totalDay,
        data: timeMap,
        curPosition: 15
      }
    },
    upsAndDowns (num) {
      return num * 1 >= 0 ? this.ups : this.downs
    },
    percentage (num) {
      let numVal = parseFloat((num * 100).toFixed(2))
      return isNaN(numVal) ? 0 : numVal
    },
    mathMin (arrs = []) {
      if (arrs.length === 0) { return false }
      var min = arrs[0]
      for (var i = 1, ilen = arrs.length; i < ilen; i += 1) {
        if (arrs[i] < min && arrs[i] !== null) {
          min = arrs[i]
        }
      }
      return min
    },
    splitWnumber (number) {
      if (isNaN(number)) { return 0 }
      return (number / 10000).toFixed(2)
    },
    fontSizeRem (val) {
      let html = document.documentElement
      let fontSize = html.style.fontSize.replace('px', '')
      return fontSize * val
    }
  },
  created () {
    const that = this
    document.onkeydown = function (event) {
      // 事件对象兼容
      const e1 = event || window.event
      that.keyCode = e1.keyCode
      setTimeout(() => {
        that.keyCode = 0
      }, 500)
    }
  },
  activated () {
    this.getTimerShaft()
    this.$parent.bindKey && this.$parent.bindKey(this.$route.name)
  }
}
